import { clientOfferTermsReadSchema, type ClientOfferTerms } from "@hakili/contracts";

/**
 * `CLIENT-OFFER-TERMS` (D-1102-3): the four terms of the offer the buyer retained, read from `retainedOffer.terms` through the contract's LENIENT twin (an unknown extra key is kept
 * out of the way, a missing or malformed block is `null`). **Absent or unreadable is `null`, never a block of zeros**: an older answer draws no row (D-1020-7, the browser invents nothing).
 */
export const offerTermsFrom = (raw: unknown): ClientOfferTerms | null => {
  const read = clientOfferTermsReadSchema.safeParse(raw);
  return read.success ? read.data : null;
};
